<ion-content fullscreen="true">
	<div style="height: 100%; width: 100%; display: flex; flex-direction: column">
		<img class="logo" src="/assets/images/logo.svg" />

		@if (locationPermissionAvailable) {
			<div class="block" style="z-index: 1">
				<img style="margin: 0 auto 10px" src="/assets/icon/location-start.svg" />
				<h1>{{ 'home.permissions.location.title' | translate }}</h1>
				<p>{{ 'home.permissions.location.description' | translate }}</p>
				<ion-button style="margin-bottom: 15px" (click)="requestLocationPermission()">
					{{ 'home.permissions.location.activate' | translate }}
				</ion-button>
				<h4 (click)="locationPermissionAvailable = false; close()">
					{{ 'home.permissions.location.notNow' | translate }}
				</h4>
			</div>
		}

		@if (pNPermissionAvailable) {
			<div class="block" style="z-index: 0">
				<img style="margin: 0 auto 10px" src="/assets/icon/bell-ring.svg" />
				<h1>{{ 'home.permissions.notifications.title' | translate }}</h1>
				<p>{{ 'home.permissions.notifications.description' | translate }}</p>
				<ion-button style="margin-bottom: 15px" (click)="requestPnPermission()">
					{{ 'home.permissions.notifications.activate' | translate }}
				</ion-button>
				<h4 (click)="pNPermissionAvailable = false; close()">
					{{ 'home.permissions.notifications.later' | translate }}
				</h4>
			</div>
		}
	</div>
</ion-content>
<ion-footer>
	<app-lang-switcher style="margin: 0 auto 5vh"></app-lang-switcher>
</ion-footer>
